<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import DatatableRates from '@components/datatablegn/DatatableRates'
import { axiosGetPost } from '@router/axiosGetPost'
import ratesData from './ratesData'
import { downloadRequest } from '@components/downloadRequest'
import AddRateLcl from '@/src/components/contract/AddRateLcl'
import RequestInfo from '@/src/components/request/requestInfo'

export default {
  page: {
    title: 'Reviews',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatatableRates,
    AddRateLcl,
    RequestInfo,
  },
  data() {
    return {
      request_id: this.$route.params.id,
      dataRates: [],
      title: 'Reviews',
      loandingDataRates: false,
      loandingBTab: false,
      isTesting: false,
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Request LCL',
          href: '/',
          active: true,
        },
        {
          text: 'Reviews',
          active: true,
        },
      ],
      modalComponent: null,
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
      historyData: [],
      loadingData: false,
      tabIndex: 0,
      ratesLength: 0,
      ratesTableIndex: 0,
      ratesSuggestedLength: 0,
      ratesCurrencyLength: 0,
      ratesDuplicatedLength: 0,
      isDuplicated: true,
    }
  },
  computed: {},
  created() {
    this.request_id = this.$route.params.id
    if (this.isTesting) {
      this.testData()
    } else {
      //this.hasSurchargers()
      this.fetchRate()
    }
  },
  mounted() {
    this.$root.$emit('closeModal', () => {
      this.saveModal()
    })
  },
  methods: {
    saveModal() {
      this.showModal = false
    },
    testData() {
      this.dataRates = ratesData.review
      this.loandingDataRates = false
      this.headsRates()
    },
    fetchRate() {
      this.loandingDataRates = true
      if (!this.isTesting) {
        axiosGetPost(
          'post',
          '/contractsLcl/review_rates',
          {
            request_id: this.request_id,
          },
          'Load data Review Surcharge / Rates LCL'
        ).then((response) => {
          let data = response
          this.dataRates = data.review
          this.isDuplicated = data.review.is_duplicated
          this.headsRates()
          this.loandingDataRates = false
          return data
        })
      } else {
        this.loandingDataRates = false
      }
    },
    headsRates() {
      this.ratesLength = this.dataRates['rw_founds'][0].length
      this.ratesSuggestedLength = this.dataRates['rw_suggested'][0].length
      this.ratesCurrencyLength = this.dataRates['rw_currency'][0].length
      this.ratesDuplicatedLength = this.dataRates['rw_duplicated'][0].length
    },
    downloadFileRequest(id) {
      downloadRequest(id, 'LCL')
    },
    addRow() {
      this.showModal = true
      this.loadingData = true
      this.modalComponent = 'AddRateLcl'
      this.modalTitle = 'Add / Include Rate LCL'
      this.loadingData = false
    },
    downloadFileImp(id) {
      axiosGetPost(
        'get',
        '/contractsLcl/downloadF/' + id,
        {},
        'Download File Lcl. Client Owner'
      ).then((response) => {
        console.log(response)
        let data = response.data
        if (data.success === true) {
          var link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = data.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              data.status +
              ' Error: ' +
              data.error
          )
        }
        return data
      })
    },
    redirectRequestList() {
      localStorage.setItem('searchRequestListLcl', this.request_id)
      this.$router.push({ name: 'LCL' })
    },
    redirectGoodAndFails() {
      this.$router.push({ path: '/failure_review_lcl/' + this.request_id })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group row">
              <div class="col-md-2">
                <h4 class="header-title mt-0 mb-1"
                  >Review - Request: {{ 'LCL - ' + request_id }}</h4
                >
              </div>
              <div class="mb-md-2 col-md-8 text-center">
                <button
                  class="btn btn-sm my-0 btn-outline-success"
                  title="Reload"
                  @click="fetchRate()"
                  >Reload Rates <i class="uil uil-sync"></i> </button
                >&nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Download File"
                  @click="downloadFileRequest(request_id)"
                  >Download File <i class="uil uil-cloud-download"></i> </button
                >&nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Add Rates"
                  @click="addRow"
                  >Add Rate <i class="uil uil-plus"></i> </button
                >&nbsp;
                <button
                  v-if="!isDuplicated"
                  class="btn btn-sm my-0 btn-outline-warning"
                  title="Donwload Op."
                  @click="downloadFileImp(request_id)"
                >
                  Download File Op</button
                >&nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Good & Fails"
                  @click="redirectGoodAndFails"
                  >Good & Fails <i class="uil uil-atm-card"/></button
                >&nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-primary"
                  title="Request list"
                  @click="redirectRequestList"
                  >Request list
                  <i class="uil uil-file-bookmark-alt"></i> </button
                >&nbsp;
              </div>
              <div class="col-md-2 text-right">
                <div v-if="(tabIndex === 0) & (ratesTableIndex === 0)">
                  <h4 class="header-title mt-0 mb-1">
                    <i class="uil uil-usd-circle" />
                    Rates Currency: {{ ratesCurrencyLength }}
                  </h4>
                </div>

                <div v-else-if="(tabIndex === 0) & (ratesTableIndex === 1)">
                  <h4 class="header-title mt-0 mb-1">
                    <i class="uil-thumbs-up" />
                    Good Rates: {{ ratesLength }}
                  </h4>
                </div>

                <div v-else-if="(tabIndex === 0) & (ratesTableIndex === 2)">
                  <h4 class="header-title mt-0 mb-1">
                    <i class="uil uil-lightbulb-alt" />
                    Suggested Rates: {{ ratesSuggestedLength }}
                  </h4>
                </div>

                <div v-else-if="(tabIndex === 0) & (ratesTableIndex === 3)">
                  <h4 class="header-title mt-0 mb-1">
                    <i class="uil uil-file-copy-alt" />
                    Duplicated Rates: {{ ratesDuplicatedLength }}
                  </h4>
                </div>
              </div>
            </div>
            <RequestInfo :request-id="request_id" :module="'LCL'" />
            <div class="row">
              <div class="mb-md-2 col-md-12">
                <b-tabs v-model="tabIndex">
                  <!-- Rates Tab **************************************************************  -->
                  <b-tab title="Rates" active>
                    <div
                      v-if="loandingDataRates"
                      class="row align-items-center justify-content-center"
                      style="height: 300px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <b-spinner
                          label="Loading..."
                          variant="secondary"
                          class="ml-3"
                        ></b-spinner>
                      </div>
                    </div>
                    <div v-else>
                      <b-tabs
                        pills
                        justified
                        class="navtab-bg"
                        v-model="ratesTableIndex"
                      >
                        <b-tab title="Currency" active>
                          <div>
                            <DatatableRates
                              :table-data="dataRates['rw_currency']"
                              :type-table="'rw_currency'"
                              :contracts-id="dataRates['contracts_id']"
                              :request-id="request_id"
                              :inc-options="['edit', 'search']"
                              :count-contracts="dataRates['count_contracts']"
                              module="lcl"
                            />
                          </div>
                        </b-tab>
                        <b-tab title="Found">
                          <DatatableRates
                            :table-data="dataRates['rw_founds']"
                            :type-table="'rw_founds'"
                            :contracts-id="dataRates['contracts_id']"
                            :request-id="request_id"
                            :inc-options="['edit', 'search']"
                            :count-contracts="dataRates['count_contracts']"
                            module="lcl"
                          />
                        </b-tab>
                        <b-tab title="Suggested">
                          <DatatableRates
                            :table-data="dataRates['rw_suggested']"
                            :type-table="'rw_suggested'"
                            :contracts-id="dataRates['contracts_id']"
                            :request-id="request_id"
                            :inc-options="['add', 'search']"
                            :count-contracts="dataRates['count_contracts']"
                            module="lcl"
                          />
                        </b-tab>
                        <b-tab title="Duplicated">
                          <DatatableRates
                            :table-data="dataRates['rw_duplicated']"
                            :type-table="'rw_duplicated'"
                            :contracts-id="dataRates['contracts_id']"
                            :request-id="request_id"
                            :inc-options="['edit', 'search']"
                            :count-contracts="dataRates['count_contracts']"
                            module="lcl"
                          />
                        </b-tab>
                      </b-tabs>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>
        <AddRateLcl
          v-if="modalComponent === 'AddRateLcl' && loadingData === false"
          :request-id="request_id"
        />
        <template v-slot:modal-footer>
          <b-button variant="light" @click="saveModal()">Close</b-button>
          <b-button
            v-if="
              loadingData === false &&
                modalErrorShow === false &&
                modalComponent === 'searchSurchargesHistory'
            "
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
  </Layout>
</template>
<style type="text/css">
.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>
